module.exports = __webpack_public_path__ + "img/LUB00399.3e5bdcee.png";